import { useEffect, useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页', icon: 'ri-home-5-line' },
  { to: '/topics', label: '热门瓜料', icon: 'ri-fire-line' },
  { to: '/community', label: '讨论区', icon: 'ri-chat-smile-2-line' },
  { to: '/about', label: '关于我们', icon: 'ri-information-line' },
];

const marqueeText =
  '理性吃瓜 · 站内内容均为网友讨论与公开信息整理，不代表事实结论　·　请勿传播他人隐私　·　发现内容有误欢迎来函更正';

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const value = keyword.trim();
    setMenuOpen(false);
    if (!value) {
      navigate('/topics');
      return;
    }
    navigate(`/topics?q=${encodeURIComponent(value)}`);
  };

  return (
    <header className="sticky top-0 z-50 w-full">
      <div className="w-full overflow-hidden bg-secondary-950 py-1.5 text-background-100">
        <div className="flex w-max animate-marquee whitespace-nowrap text-[11px] tracking-wide md:text-xs">
          <span className="px-6">{marqueeText}</span>
          <span className="px-6">{marqueeText}</span>
        </div>
      </div>

      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? 'border-background-200/80 bg-background-50/95 backdrop-blur'
            : 'border-transparent bg-background-50'
        }`}
      >
        <div className="mx-auto flex h-16 w-full items-center gap-4 px-4 md:h-[70px] md:gap-6 md:px-6">
          <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label="爆料吃瓜首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 md:h-10 md:w-10">
              <i className="ri-fire-fill text-lg md:text-xl" aria-hidden="true" />
            </span>
            <span className="flex flex-col leading-none">
              <strong className="font-heading text-lg font-black tracking-tight text-foreground-950 md:text-xl">
                爆料吃瓜
              </strong>
              <span className="mt-0.5 hidden text-[10px] font-medium uppercase tracking-[0.2em] text-foreground-400 md:block">
                hot topics &amp; talk
              </span>
            </span>
          </Link>

          <nav aria-label="主导航" className="hidden items-center gap-1 lg:flex">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                  }`
                }
              >
                <i className={item.icon} aria-hidden="true" />
                {item.label}
              </NavLink>
            ))}
          </nav>

          <form onSubmit={handleSearch} className="ml-auto hidden items-center md:flex" role="search">
            <div className="flex h-10 items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 focus-within:border-primary-300">
              <i className="ri-search-line text-base text-foreground-400" aria-hidden="true" />
              <input
                type="search"
                value={keyword}
                onChange={(event) => setKeyword(event.target.value)}
                placeholder="搜瓜料 / 关键词"
                aria-label="搜索瓜料"
                className="w-32 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none lg:w-40"
              />
            </div>
          </form>

          <Link
            to="/community"
            className="ml-auto hidden shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 md:ml-0 md:flex"
          >
            <i className="ri-group-line" aria-hidden="true" />
            社群入口
          </Link>

          <button
            type="button"
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
            className="ml-auto flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} aria-hidden="true" />
          </button>
        </div>

        {menuOpen && (
          <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 lg:hidden">
            <form onSubmit={handleSearch} className="mb-4" role="search">
              <div className="flex h-11 items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3">
                <i className="ri-search-line text-base text-foreground-400" aria-hidden="true" />
                <input
                  type="search"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="搜瓜料 / 关键词"
                  aria-label="搜索瓜料"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
              </div>
            </form>
            <nav aria-label="移动端导航" className="flex flex-col gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  onClick={() => setMenuOpen(false)}
                  className={({ isActive }) =>
                    `flex items-center gap-2 rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`
                  }
                >
                  <i className={item.icon} aria-hidden="true" />
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <Link
              to="/community"
              onClick={() => setMenuOpen(false)}
              className="mt-4 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
            >
              <i className="ri-group-line" aria-hidden="true" />
              前往社群入口
            </Link>
          </div>
        )}
      </div>
    </header>
  );
}